import './styles/tag.css';

export default function Tag({ swatch, children }) {
    return (
        <span className="tag">
            {swatch && <span className={`tag__swatch tag__swatch--${swatch}`} aria-hidden="true" />}
            {children}
        </span>
    );
}
